import {
  buildSecondaryTopLevel,
  sumStorage,
  type StructuralHierarchyNode,
} from './buildClusterTopLevel';
import type { ExplorationSecondary, ExplorationVolume } from '../../types/exploration';

export type FullHierarchyNode = StructuralHierarchyNode;

export interface BuildFullHierarchyOptions {
  secondary: ExplorationSecondary;
  tagKey?: string;
}

export function buildFullHierarchy(
  volumes: ExplorationVolume[],
  opts: BuildFullHierarchyOptions
): FullHierarchyNode {
  const topChildren = buildSecondaryTopLevel(volumes, opts.secondary, opts.tagKey);

  return {
    type: 'root',
    name: 'All',
    children: topChildren,
    count: volumes.length,
    value: sumStorage(volumes),
  };
}
